<template>
  <div>
    <v-autocomplete
      :value="selected"
      @input="select"
      :items="items"
      :label="lang.scheduler.new.widget.filters.employees.title"
      :no-data-text="lang.scheduler.new.widget.filters.employees.noEmployees"
      :loading="loading"
      :disabled="loading"
      item-value="id"
      item-text="name"
      :return-object="true"
      :clearable="false"
      clear-icon="mdi-broom"
      prepend-inner-icon="mdi-account-multiple-plus"
      :menu-props="{ offsetY: true }"
      autocomplete="off"
      class="employees-miniautocomplete hide-chips"
      filled
      multiple
      hide-details
    >
      <template v-slot:selection>
       <!--  <v-chip
          :input-value="selected"
          close
          @click:close="remove(item)"
          class="chip--select-multi"
        >
          <Avatar
            :photo="item.avatar"
            :size="15"
            class="ml-2 mr-4"
          />
          {{ item.name }}
        </v-chip> -->
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <Avatar
            :photo="item.avatar"
            :size="40"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ getCatNames(item.categories) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Avatar from '@/components/users/templates/Avatar'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Avatar },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    services_in: {
      type: Array,
      default: () => {
        return []
      }
    },
    employees: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: (this.value ? [ ...this.value ] : [])
    }
  },
  computed: {
    items: {
      get () {
        const list = this.services_in || []
        const cats_in = list.reduce((add, val) => add.concat(val.cat), [])
        let cats = [ ...new Set(cats_in) ]
        var employees_ = this.employees || []
        var employees = employees_/* .filter((emp) => (emp.categories || []).some(cat => cat.catalog === 'services')) || [] */
        var groups = {
          recommended: [],
          assistants: [],
          others: []
        }
        employees.forEach((emp) => {
          let match_cats = (emp.categories || []).filter(cat => cats.indexOf(cat.id) > -1) || [],
              mcats_len = (emp.categories.length > 0 ? match_cats.length || 0 : cats_in.length),
              icats_len = cats.length || 0
          if (mcats_len >= icats_len) {
            groups.recommended.push(emp)
          } else if (mcats_len > 0) {
            groups.assistants.push(emp)
          } else {
            groups.others.push(emp)
          }
        })
        Object.keys(groups).map((index) => {
          if (groups[index].length > 0) {
            groups[index].unshift({ header: this.lang.scheduler.new.widget.filters.employees.groups[index] })
          }
        })
        const flatten = Object.values(groups).reduce((add, val) => add.concat(val), [])
        return [ ...flatten ]
      },
      set () {
        /* */
      }
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', [ ...this.selected ])
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = [ ...this.value ]
      }
    }
  },
  methods: {
    select (items) {
      this.$set(this, 'selected', [ ...items ])
    },
    remove (item) {
      const index = this.selected.findIndex(el => el.id === item.id)
      if (index >= 0) this.selected.splice(index, 1)
    },
    getCatNames (cats) {
      let names = cats.map(e => e.name) || []
      return (names.length > 0 ? names.join(' / ') : this.lang.categories.new.all_cat)
    }
  }
}
</script>

<style scoped src="../../styles/autocomplete.scss" lang="scss"></style>
<style lang="scss">
#app .employees-miniautocomplete {
  border-radius: 0px !important;
  margin: 0px;
  .v-input__slot {
    max-height: 32px !important;
    min-height: 32px !important;
    padding: 0px 2px 0px 9px !important;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .v-input__prepend-inner {
      margin-top: 5px !important;
    }
    .v-select__slot {
      padding-left: 5px;
      .v-input__append-inner {
        margin-top: 3px !important;
      }
      .v-label {
        font-size: 13px !important;
        position: absolute !important;
        top: 7px !important;
        left: 3px !important;
        transform: none !important;
      }
      .v-select__selections {
        display: inline-block;
        margin-top: 0px !important;
        padding-top: 0px !important;
        min-height: 32px !important;
        .v-chip {
          display: inline-block;
          width: 100%;
          margin-bottom: 0px !important;
          background: #1976d2 !important;
          color: #fff !important;
          .v-chip__content {
            line-height: 15px !important;
            .thumb-content .v-avatar {
              width: 19px !important;
              min-width: 19px !important;
              height: 19px !important;
              margin: 2px !important;
            }
            .v-chip__close {
              color: #fff !important;
              position: absolute;
              top: 2px;
              right: 12px;
            }
          }
        }
      }
    }
  }
  &.v-input--is-focused {
    .v-label {
      visibility: hidden;
    }
  }
}
</style>
